/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';

export default class AbstractResponsiveComponent extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	get data() {
		return {
			default: null,
			tablet: null,
			phone: null,
		};
	}

	getClassName() {
		return this.className;
	}

	get className() {
		return 'BannerResponsiveComponent';
	}

	get defaultClassNames() {
		const { tablet, phone } = this.data;

		let className = `${this.getClassName()} ${this.className}--default`;

		if (!tablet) {
			className += ` ${this.className}--tablet`;
		}

		if (!phone && !tablet) {
			className += ` ${this.className}--phone`;
		}

		return className;
	}

	get tabletClassNames() {
		const { phone } = this.data;

		let className = `${this.getClassName()} ${this.className}--tablet`;

		if (!phone) {
			className += ` ${this.className}--phone`;
		}

		return className;
	}

	get phoneClassNames() {
		return `${this.getClassName()} ${this.className}--phone`;
	}

	get showPlaceholder() {
		return false;
	}

	get placeholder() {
		return null;
	}

	getPlaceholder() {
		if (!this.data) {
			return null;
		}

		// If any of the devices has a value, don't show the placeholder
		if (Object.values(this.data).some((value) => value)) {
			return null;
		}

		const Placeholder = this.placeholder;

		if (this.showPlaceholder && Placeholder) {
			return <Placeholder className={`${this.className}-placeholder`} />;
		}
	}

	get content() {
		return null;
	}

	getContent(deviceKey, children) {
		if (!this.data) {
			return null;
		}

		const deviceData = this.data[deviceKey];
		const Content = this.content;

		if (!Content || !deviceData) {
			return null;
		}

		const className = this[`${deviceKey}ClassNames`];

		return (
			<Content deviceData={deviceData} deviceKey={deviceKey} className={className} self={this}>
				{children}
			</Content>
		);
	}

	view(vnode) {
		const children = vnode.children;

		return (
			<div className={`${this.className}-container`}>
				{this.getPlaceholder()}

				{this.getContent('default', children)}
				{this.getContent('tablet', children)}
				{this.getContent('phone', children)}
			</div>
		);
	}
}
